<script lang="ts" setup>
import { Button } from '@brighterly/lib-lumee-ui'

import { useSubscriptionStore } from '@entities/subscription'
import { trackEvent } from '@shared/lib/amplitude'
import { LoaderBlockDomain } from '@shared/ui/loaders'

defineOptions({
  name: 'ModalRetryProcessing',
})

const AppModal = defineAsyncComponent(() => import('@shared/ui/modals').then((module) => module.AppModal))

const subscriptionStore = useSubscriptionStore()

const title = 'Payment is processing...'

onMounted(() => {
  trackEvent('Popup_view', {
    feature: 'subscription',
    name: 'retry_payment_processing',
    text: title,
    subscription_id: subscriptionStore.getPaymentRetrySubscriptionId,
  })
})

const setSubmit = (): void => {
  trackEvent('Popup_close', { feature: 'subscription', name: 'retry_payment_processing', value: 'return_to_homepage' })

  subscriptionStore.setModalRetryPaymentProcessing(false)
}
</script>

<template>
  <AppModal
    :show-button-close="false"
  >
    <template #contentSlot>
      <div class="rp">
        <div class="rp__loader">
          <LoaderBlockDomain />
        </div>
        <div class="rp__info">
          <div
            class="rp__content"
          >
            <h4 class="rp__heading-s btly-text-heading-s">
              {{ title }}
            </h4>
            <div class="rp__body-l btly-text-body-l">
              This may take some time to complete.
              <br>
              We'll notify you once it's done.
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #bottomSlot>
      <Button
        view="secondary"
        fill
        text="Return to Homepage"
        @click="setSubmit"
      />
    </template>
  </AppModal>
</template>

<style scoped lang="scss" src="./ModalRetryProcessing.scss" />
